(function () {
  function byId(list) {
    let map = {};
    for (let i = 0; i < list.length; i++) map[list[i].dataset.layer] = list[i];
    return map;
  }

  function init(root) {
    if (!root || root.dataset.vxInit) return;
    root.dataset.vxInit = '1';

    let navs = Array.prototype.slice.call(root.querySelectorAll('.vx-cal__nav-item'));
    let layers = Array.prototype.slice.call(root.querySelectorAll('.vx-cal__layer'));
    let videos = Array.prototype.slice.call(root.querySelectorAll('.vx-cal__video'));
    let navList = root.querySelector('.vx-cal__nav');
    let titleWrap = root.querySelector('[data-title-wrap]');
    let descWrap = root.querySelector('[data-desc-wrap]');
    let titleEl = root.querySelector('[data-title]');
    let descEl = root.querySelector('[data-desc]');
    let dotEl = root.querySelector('.vx-cal__dot');
    if (!navs.length || !titleWrap || !descWrap || !titleEl || !descEl) return;

    let navsById = byId(navs);
    let layersById = byId(layers);
    let slot = 0;
    let current = -1;
    let seen = false;
    let navHover = '';
    let layerHover = '';
    let contentTimer = 0;
    let pauseTimer = 0;
    let reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function setHover(map, prev, next) {
      if (prev && prev !== next && map[prev]) map[prev].classList.remove('is-hover');
      if (next && map[next]) map[next].classList.add('is-hover');
    }

    function swapText(title, desc, isIntro) {
      titleEl.textContent = title;
      descEl.textContent = desc;
      if (isIntro) descEl.classList.add('is-intro');
      else descEl.classList.remove('is-intro');
      if (dotEl) dotEl.hidden = !String(title).trim();
      if (String(title).trim()) titleWrap.classList.remove('is-idle');
      else titleWrap.classList.add('is-idle');
    }

    function activeVideo() {
      for (let i = 0; i < videos.length; i++) {
        if (videos[i].classList.contains('is-active')) return videos[i];
      }
      return null;
    }

    function ensureSrc(video) {
      if (!video) return;
      let pending = video.getAttribute('data-src');
      if (!pending) return;
      if (video.getAttribute('src') !== pending) video.src = pending;
      video.removeAttribute('data-src');
    }

    function playIfVisible(on) {
      let active = activeVideo();
      if (!active) return;
      if (!on) {
        active.pause();
        return;
      }
      ensureSrc(active);
      if (!active.getAttribute('src')) return;
      let playPromise = active.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
    }

    function crossfade(src, poster) {
      if (!src || videos.length < 2) return;
      let prev = videos[slot];
      if (prev.getAttribute('src') === src && prev.classList.contains('is-active')) return;

      slot = slot ? 0 : 1;
      let next = videos[slot];
      if (poster) next.poster = poster;
      next.src = src;
      next.removeAttribute('data-src');

      if (!seen) {
        next.classList.add('is-active');
        prev.classList.remove('is-active');
        prev.pause();
        return;
      }

      function swap() {
        next.classList.add('is-active');
        prev.classList.remove('is-active');
        clearTimeout(pauseTimer);
        pauseTimer = setTimeout(function () {
          prev.pause();
        }, 650);
      }

      let playPromise = next.play();
      if (playPromise && playPromise.then) playPromise.then(swap).catch(swap);
      else swap();
    }

    function updateContent(nav) {
      let title = nav.dataset.title || '';
      let desc = nav.dataset.desc || '';
      let src = nav.dataset.video || '';
      let poster = nav.dataset.poster || '';
      let idx = parseInt(nav.dataset.index, 10) || 0;
      let down = idx > current;
      current = idx;

      clearTimeout(contentTimer);
      titleWrap.classList.remove('is-exit-down', 'is-exit-up', 'is-from-down', 'is-from-up');

      if (reduceMotion.matches) {
        descWrap.classList.remove('is-out');
        swapText(title, desc, false);
      } else {
        titleWrap.classList.add(down ? 'is-exit-down' : 'is-exit-up');
        descWrap.classList.add('is-out');
        contentTimer = setTimeout(function () {
          swapText(title, desc, false);
          titleWrap.classList.remove('is-exit-down', 'is-exit-up');
          titleWrap.classList.add(down ? 'is-from-down' : 'is-from-up');
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              titleWrap.classList.remove('is-from-down', 'is-from-up');
              descWrap.classList.remove('is-out');
            });
          });
        }, 300);
      }

      crossfade(src, poster);
    }

    function activate(id) {
      let nav = navsById[id];
      if (!nav || nav.classList.contains('is-active')) return;

      for (let i = 0; i < navs.length; i++) {
        navs[i].classList.remove('is-active');
        navs[i].setAttribute('aria-selected', 'false');
      }
      for (let j = 0; j < layers.length; j++) layers[j].classList.remove('is-active');

      nav.classList.add('is-active');
      nav.setAttribute('aria-selected', 'true');
      if (layersById[id]) layersById[id].classList.add('is-active');
      updateContent(nav);
    }

    root._vxCalActivate = activate;

    function closestIn(event, selector) {
      let node = event.target;
      if (!node) return null;
      if (node.nodeType !== 1) node = node.parentElement;
      if (!node || !node.closest) return null;
      let el = node.closest(selector);
      if (!el || !root.contains(el)) return null;
      return el;
    }

    root.addEventListener('click', function (event) {
      let nav = closestIn(event, '.vx-cal__nav-item');
      if (nav) {
        activate(nav.dataset.layer);
        return;
      }
      let layer = closestIn(event, '.vx-cal__layer');
      if (layer) activate(layer.dataset.layer);
    });

    root.addEventListener('mouseover', function (event) {
      let nav = closestIn(event, '.vx-cal__nav-item');
      if (nav) {
        if (nav.dataset.layer === navHover) return;
        setHover(layersById, navHover, nav.dataset.layer);
        navHover = nav.dataset.layer;
        return;
      }
      let layer = closestIn(event, '.vx-cal__layer');
      if (layer) {
        if (layer.dataset.layer === layerHover) return;
        setHover(navsById, layerHover, layer.dataset.layer);
        layerHover = layer.dataset.layer;
      }
    });

    root.addEventListener('mouseout', function (event) {
      let related = event.relatedTarget;
      if (related && related.nodeType !== 1) related = related.parentElement;
      let nav = closestIn(event, '.vx-cal__nav-item');
      if (nav) {
        let nextNav = related && related.closest && related.closest('.vx-cal__nav-item');
        if (nextNav && root.contains(nextNav)) return;
        setHover(layersById, navHover, '');
        navHover = '';
        return;
      }
      let layer = closestIn(event, '.vx-cal__layer');
      if (layer) {
        let nextLayer = related && related.closest && related.closest('.vx-cal__layer');
        if (nextLayer && root.contains(nextLayer)) return;
        setHover(navsById, layerHover, '');
        layerHover = '';
      }
    });

    if (navList) {
      navList.addEventListener('keydown', function (event) {
        let key = event.key;
        if (key !== 'ArrowDown' && key !== 'ArrowUp' && key !== 'Home' && key !== 'End') return;
        let idx = -1;
        for (let i = 0; i < navs.length; i++) {
          if (navs[i].classList.contains('is-active')) {
            idx = i;
            break;
          }
        }
        if (key === 'ArrowDown') idx = idx < 0 ? 0 : Math.min(navs.length - 1, idx + 1);
        else if (key === 'ArrowUp') idx = idx < 0 ? navs.length - 1 : Math.max(0, idx - 1);
        else if (key === 'Home') idx = 0;
        else idx = navs.length - 1;
        event.preventDefault();
        activate(navs[idx].dataset.layer);
        navs[idx].focus();
      });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          let entry = entries[0];
          if (!entry) return;
          seen = entry.isIntersecting;
          playIfVisible(seen);
        },
        { rootMargin: '200px 0px' }
      ).observe(root);
    } else {
      seen = true;
      playIfVisible(true);
    }

  }

  function boot(scope) {
    let roots = (scope || document).querySelectorAll('[data-vx-cal]');
    for (let i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    let section = event.target;
    if (!section || !section.querySelectorAll) return;
    let roots = section.querySelectorAll('[data-vx-cal]');
    for (let i = 0; i < roots.length; i++) {
      delete roots[i].dataset.vxInit;
      init(roots[i]);
    }
  });

  document.addEventListener('shopify:block:select', function (event) {
    let detail = event.detail;
    if (!detail || !detail.sectionId) return;
    let root = document.querySelector('[data-vx-cal="' + detail.sectionId + '"]');
    if (root && typeof root._vxCalActivate === 'function') root._vxCalActivate(detail.blockId);
  });
})();
